
export default function formFornecedorUpdateDTO({
        IDCATEGORIAFORNECEDOR,
        NOME_FANTASIA, 
        RAZAO_SOCIAL, 
        CNPJ_CPF, 
        TELEFONE,
        EMAIL, 
        RUA, 
        NUMERO, 
        BAIRRO, 
        COMPLEMENTO, 
        CEP, 
        CIDADE,
        uf,
        OBSERVACAO, 
        ATIVO
    }){ 
        return{
            IDCATEGORIAFORNECEDOR,
            NOME_FANTASIA, 
            RAZAO_SOCIAL, 
            CNPJ_CPF, 
            TELEFONE,
            EMAIL, 
            RUA, 
            NUMERO, 
            BAIRRO, 
            COMPLEMENTO, 
            CEP, 
            CIDADE,
            uf,
            OBSERVACAO,
            ATIVO
    }
}